(() => {
  const initialize = (root) => {
  if (root.dataset.qrdeskReady) return;
  root.dataset.qrdeskReady = 'true';
  const tabs = [...root.querySelectorAll('[data-qrdesk-mode]')];
  const activate = (tab, focus) => {
    tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = root.querySelector('#' + CSS.escape(item.getAttribute('aria-controls')));
      if (panel) panel.hidden = !selected;
    });
    root.dataset.mode = tab.dataset.qrdeskMode;
    if (focus) tab.focus({ preventScroll: true });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab, true));
    tab.addEventListener('keydown', (event) => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      activate(tabs[next], true);
    });
  });
  const finder = root.querySelector('[data-qrdesk-finder]');
  const occasion = root.querySelector('[data-qrdesk-occasion]');
  const programme = root.querySelector('[data-qrdesk-programme]');
  const status = root.querySelector('[data-qrdesk-finder-status]');
  const guide = root.querySelector('[data-qrdesk-occasion-guide]');
  const choices = [...root.querySelectorAll('[data-qrdesk-choice]')];
  if (finder && occasion && programme && status && guide && choices.length) {
    const defaultStatus = status.textContent;
    const matches = (choice, value) => value === 'all' || choice.dataset.audiences.split(' ').includes(value);
    [...occasion.options].forEach((option) => {
      option.disabled = !choices.some((choice) => matches(choice, option.value));
    });
    const updateOccasion = () => {
      const option = occasion.selectedOptions[0];
      const filtered = occasion.value !== 'all';
      const visible = choices.filter((choice) => matches(choice, occasion.value));
      choices.forEach((choice) => { choice.hidden = !visible.includes(choice); });
      programme.classList.toggle('is-filtered', filtered);
      const collection = visible.find((choice) => choice.dataset.collectionUrl);
      guide.hidden = !filtered || !collection;
      if (!guide.hidden) {
        guide.querySelector('[data-qrdesk-guide-title]').textContent = collection.dataset.collectionTitle;
        guide.querySelector('[data-qrdesk-guide-copy]').textContent = option.dataset.guide || '';
        guide.querySelector('[data-qrdesk-guide-link]').href = collection.dataset.collectionUrl;
      }
      status.textContent = filtered ? status.dataset.message.replace('[occasion]', option.textContent.trim()) : defaultStatus;
    };
    occasion.addEventListener('change', updateOccasion);
    updateOccasion();
    finder.hidden = false;
  }
  const dialog = root.querySelector('dialog');
  const opener = root.querySelector('[data-qrdesk-open]');
  const closer = root.querySelector('[data-qrdesk-close]');
  if (!dialog || !opener || !closer) return;
  opener.addEventListener('click', () => dialog.showModal());
  closer.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => opener.focus({ preventScroll: true }));
  };
  const initializeWithin = (node) => {
    if (node.matches?.('.qrdesk')) initialize(node);
    node.querySelectorAll('.qrdesk').forEach(initialize);
  };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
